module.exports = __webpack_public_path__ + "media/images/icon-reply@3x-6139ea7efd6d95fd21e1de8f1523f3b8.png";